import { registerPlugin } from "@capacitor/core";

/**
 * iOS Game Center 네이티브 플러그인 브리지 — `ios/App/App/GameCenterPlugin.swift`
 * (`@objc(GameCenterPlugin)` + GameKit GKLocalPlayer/GKLeaderboard)에 매핑되는 로컬 Capacitor 플러그인.
 *
 * ⚠ iOS 네이티브 프로젝트(`ios/`)는 아직 생성 전 — `npx cap add ios`(Mac) 후 Swift 플러그인을 배치해야
 * 실제 동작한다. 그 전까지 비-iOS/미구현 환경에서는 호출이 reject되며, GameCenterLeaderboardClient가 흡수한다.
 */
export interface GameCenterNativePlugin {
  /** GKLocalPlayer 인증 상태(미인증 시 인증 트리거). */
  isAvailable(): Promise<{ available: boolean }>;
  /** GKLeaderboard에 점수 제출. */
  submitScore(options: { leaderboardId: string; score: number }): Promise<void>;
}

export const GameCenterNative = registerPlugin<GameCenterNativePlugin>("GameCenter");
